import { useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import TabLayout from "./_components/TabLayout";

import AppLayout from "@/layouts/AppLayout";
import { useSectionNavLinks } from "../_utils";
import { useQuery } from "@apollo/client";
import { SECTION_DETAILS_HEADER_QUERY } from "../queries";
import { SectionDetailsHeader } from "../_components/SectionDetailsHeader";
import Banner from "@/components/Banner";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";

export default function OperationsLayout() {
  const { sectionId, committeeId } = useParams();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const isCommitteeDetail = Boolean(committeeId);

  const { data, previousData } = useQuery(SECTION_DETAILS_HEADER_QUERY, {
    variables: { sectionId },
    fetchPolicy: "cache-first"
  });
  const navLinks = useSectionNavLinks(sectionId);

  const cachedSection = previousData?.section;
  const section = data?.section || (cachedSection?.id === sectionId ? cachedSection : undefined);
  const { legacyId } = section || {};
  const contextValue = {
    legacyId
  };

  if (!sectionId || !legacyId) {
    return null;
  }

  const outlet = <Outlet context={{ ...contextValue, setErrorMessage }} />;

  const renderDesktopLayout = () => (
    <>
      <SectionDetailsHeader sectionId={sectionId} />
      <TabLayout>{outlet}</TabLayout>
    </>
  );

  const renderMobileLayout = () => (
    <>
      <Breadcrumb
        compactOnly
        compactTitle="Operations"
        backLink={{ to: "/sections/:sectionId", params: { sectionId: sectionId! } }}
      />
      <SectionDetailsHeader sectionId={sectionId} />
      <TabLayout>{outlet}</TabLayout>
    </>
  );

  return (
    <AppLayout
      navLinks={navLinks}
      interior
      bottomBar
      BannerComponent={errorMessage && <Banner closable={true} description={errorMessage} variant="error" />}
    >
      {isCommitteeDetail ? outlet : isMobile ? renderMobileLayout() : renderDesktopLayout()}
    </AppLayout>
  );
}
